import { useState, useCallback, useMemo } from 'react';
import isEmpty from 'ramda/es/isEmpty';

import { type Params as State } from 'app/common/api/requests/data/vending/machines/get';


type StateUpdate = Partial<State>;

const clearEmptyFields = (params: StateUpdate): StateUpdate => {
  const next: Record<string, StateUpdate[keyof StateUpdate]> = {};

  (Object.keys(params) as Array<keyof StateUpdate>).forEach((key) => {
    const value = params[key];

    if (value instanceof Array) {
      if (isEmpty(value)) return;
      if (value[0] === 0) return;
    }
    if (value === 0) {
      next[key] = value;
      return;
    }
    if (value) {
      next[key] = value;
    }
  });

  return next as StateUpdate;
};

export type VendingMachinesParams = [State, (StateUpdate) => void];
export type { State };

const defaultState: State = Object.freeze({
  sort_by_school: true, // использовать при переключении типа группировки
});
export const defaultVendingMachinesParams: VendingMachinesParams = [defaultState, () => { }];

export default function useVendingMachinesParams(): VendingMachinesParams {
  const [state, setState] = useState<State>(defaultState);

  const updateState = useCallback((params: StateUpdate) => {
    setState(currentParams => ({ ...currentParams, ...clearEmptyFields(params) }));
  }, []);

  const memoized: VendingMachinesParams = useMemo(() => [state, updateState], [state, updateState]);

  return memoized;
}
